import { Application, Container, Graphics, Rectangle } from 'pixi.js';
import TweenLite from 'gsap/TweenLite';
import TimelineLite from 'gsap/TimelineLite';
import 'gsap/PixiPlugin';

import events from '../../utils-and-data/events.js';

class FxLayer {
  constructor(props) {
    console.log('FxLayer in use', props)
    this.props = props;
    this.rootEl = document.getElementById('root');
    this.pixi = new Application(props.size.width, props.size.height, {
      resolution: window.devicePixelRatio > 1
        ? window.devicePixelRatio
        : 2,
      transparent: true,
    });
    this.pixi.stage.filterArea = new Rectangle(
      0,0, props.size.width, props.size.height
    );

    // Plonk the app.view into the dom:
    Object.assign(this.pixi.view.style, {
      position: 'absolute',
      zIndex: 2, top: 0, left: 0,
      width: '100%', height: '100%',
      userSelect: 'none', pointerEvents: 'none',
      // opacity: 0,
    });
    this.rootEl.appendChild(this.pixi.view);

    // Add the voiceLayer, just once
    this.voiceLayer = new Container();
    this.pixi.stage.addChild(this.voiceLayer);
    this.voiceLayer.layerName = 'VoiceLayer';
    this.voiceLayer.zLevel = 1;
    this.voiceLayer.clearChildren = () => {
      while (this.voiceLayer.children[0]) {
        this.voiceLayer.removeChild(this.voiceLayer.children[0]);
      }

      // Just incase the renderer has been stopped by a ghost destroying,
      // render one more single frame to ensure stage is up to date.
      this.updateFrame();
    };

    // Call this once to set the mode, and all appropriate z levels:
    this.resize(this.props.size);
    this.sortLayers();

    // Assign an update Function:
    this.pixi.ticker.add(this.updateFrame);
    this.stop();

    // Implement dev stats for animation work:
    if (process.env.NODE_ENV === 'development') {
      this.stats = require('stats.js')();
      this.stats.setMode(0);
      this.stats.domElement.classList.add('stats');
      this.rootEl.appendChild(this.stats.domElement);
    }
  }

  setZIndex = (newIndex) => {
    Object.assign(this.pixi.view.style, { zIndex: newIndex });
  }

  resize = (dims) => {
    this.pixi.renderer.resize(dims.width, dims.height);
    this.props.size = dims;

    // Clearout old scene (except for voice layer)
    while (this.pixi.stage.children[0]
      && this.pixi.stage.children[0].layerName !== 'VoiceLayer') {

      this.pixi.stage.removeChild(this.pixi.stage.children[0]);
    }

    // Make new scene:
    this.createLayers();
  }

  createLayers = () => {

    // // @TEMP code:
    // var graphics = new Graphics();
    // graphics.beginFill(0xFF3300);
    // graphics.lineStyle(0);
    // graphics.drawCircle(150, 120, 100);
    // graphics.endFill();
    // graphics.zLevel = 2;
    // this.pixi.stage.addChild(graphics);
  }

  start = () => {
    // console.log(':::::::::: FxLayer START ::::::::::')
    this.pixi.ticker.start();
  }

  stop = () => {
    // console.log(':::::::::: FxLayer STOP ::::::::::')
    this.pixi.ticker.stop();
  }

  bounce(onCompleteFn) {
    this.tl = new TimelineLite({
      onComplete: () => {
       onCompleteFn()
      }
    });
    this.tl.to(this.voiceLayer, 0.2, {
      pixi: { x: -20 },
      ease: Quart.easeInOut
    }).to(this.voiceLayer, 0.4, {
      pixi: { x: 0 },
      ease: Bounce.easeOut,
    });
  }

  destroy = () => {
    this.rootEl.removeChild(this.pixi.view);
    this.rootEl.removeChild(this.stats.domElement);
  }

  updateFrame = () => {
    this.stats && this.stats.begin();
    this.pixi.renderer.render(this.pixi.stage);
    this.stats && this.stats.end();
  }

  sortLayers() {
    this.pixi.stage.children.sort((a,b) => {
      a.zLevel = a.zLevel || 0;
      b.zLevel = b.zLevel || 0;
      return a.zLevel - b.zLevel
    });
  }
}

var rootEl = document.getElementById('root');
let fxLayer = new FxLayer({
  size: {
    width: rootEl.offsetWidth,
    height: rootEl.offsetHeight
  }
});

export default fxLayer;



// WEBPACK FOOTER //
// ./app/frontend/components/partials/fx-layer.js